import React, { useEffect } from 'react';
import './OrderNotificationToast.css';

const DURATION_MS = 9000;

function fmt(n) {
  return `$${parseFloat(n || 0).toLocaleString('es-AR', { maximumFractionDigits: 0 })}`;
}

// pos-boton-wa (19-oct): `onSendWa(orderId)` — si llega y la venta POS trae celular válido
// (main.waDisponible, decidido por el backend), el toast ofrece «Enviar por WhatsApp».
export default function OrderNotificationToast({ orders, onDismiss, onNavigateOrders, onSendWa = null }) {
  useEffect(() => {
    const t = setTimeout(onDismiss, DURATION_MS);
    return () => clearTimeout(t);
  }, [onDismiss]);

  const main  = orders[0];
  const extra = orders.length - 1;

  const isPOS = main.origin === 'POS' || String(main.origin || '').includes('POS');
  const title = isPOS
    ? `🛍️ Venta confirmada · ${fmt(main.rawTotal)}`
    : `🌐 Nuevo pedido web · ${fmt(main.rawTotal)}`;

  const items        = main.items || [];
  const visibleItems = items.slice(0, 3);
  const extraItems   = items.length - 3;

  return (
    <div className="ont" role="alert" aria-live="assertive">
      <div className="ont-header">
        <span className="ont-title">{title}</span>
        <button className="ont-close" onClick={onDismiss} aria-label="Cerrar">✕</button>
      </div>

      <div className="ont-body">
        {visibleItems.length > 0 ? (
          <ul className="ont-items">
            {visibleItems.map((item, idx) => (
              <li key={idx} className="ont-item">
                <span className="ont-item-bullet">•</span>
                <span className="ont-item-name">{item.name}</span>
                <span className="ont-item-qty">× {item.quantity}</span>
              </li>
            ))}
            {extraItems > 0 && (
              <li className="ont-item ont-item--more">
                y {extraItems} producto{extraItems !== 1 ? 's' : ''} más…
              </li>
            )}
          </ul>
        ) : (
          <div className="ont-detail-row">
            <span className="ont-num">#{main.orderNumber}</span>
            <span className="ont-total">{fmt(main.rawTotal)}</span>
          </div>
        )}

        <div className="ont-footer">
          <span>Canal: {main.payment}</span>
          <span className="ont-dot">·</span>
          <span>Pedido #{main.orderNumber}</span>
        </div>

        {extra > 0 && (
          <div className="ont-extra">+{extra} pedido{extra !== 1 ? 's' : ''} más</div>
        )}
      </div>

      {/* pos-boton-wa: enviar el comprobante directo desde la notificación (venta POS con celular) */}
      {isPOS && main.waDisponible && onSendWa && (
        <button
          className="ont-action ont-action--wa"
          onClick={() => { onSendWa(main.orderId); onDismiss(); }}
        >
          Enviar por WhatsApp
        </button>
      )}
      <button
        className="ont-action"
        onClick={() => { onNavigateOrders(); onDismiss(); }}
      >
        Ver pedido →
      </button>

      <div
        className="ont-bar"
        style={{ animationDuration: `${DURATION_MS}ms` }}
      />
    </div>
  );
}
